'use strict';

const {setHeaderHeight} = require('../common/common');
const login = require('../login/login');
const { accessibleModal } = require('../utilities/accessibility');
const DELAY_OPENING_MEGA_MENU = 100; // ms delay before opening the mega menu on hover

const SELECTORS = {
    element: '.js-header-wrap',
    itemNavigation: '.js-header-item',
    itemButton: '.js-header-btn',
    submenu: '.js-megamenu',
    megamenuBackdrop: '.js-megamenu-backdrop',
    mobileMenu: '.js-mobile-menu',
    openMobileMenu: '.js-header-openmenu',
    loginButton: '.js-step-login',
    linksToToggleActive: '.js-link'
}

const CLASSES = {
    open: 'cc-megamenu--open',
    mobileOpen: 'cc-mobilemenu--open',
    bodyClassLogin: 'js-page-registration',
    active: 'cc-active'
}

/**
 * Header class that handles the header navigation
 */
class Header {
    constructor(element) {
        this.element = element;
        this.itemNav = element.querySelectorAll(SELECTORS.itemNavigation);
        this.itemNavJQ = $(element).find(SELECTORS.itemNavigation);
        this.itemBtnJQ = $(element).find(SELECTORS.itemButton);
        this.submenuJQ = $(element).find(SELECTORS.submenu);
        this.megamenuBackdrop = element.querySelectorAll(SELECTORS.megamenuBackdrop);
        this.itemOpenMenuJQ = $(SELECTORS.openMobileMenu);
        this.mobileMenuJQ = $(SELECTORS.mobileMenu);
        this.loginButtonJQ = $(SELECTORS.loginButton);
        this.linksJQ = $(SELECTORS.linksToToggleActive);
        this.currentLevel = 0;
        this.submenuStack = [];
        this.hoverTimeout = null;
        this.hoverNav = false;
        this.hoverTouchElement = null;
        this.initEvents();
        this.checkActiveStateFromURL();
        this.customClicks();
        setHeaderHeight();
    }

    initEvents() {
        if (window.isDesktop) {
            this.itemNav.forEach((el) => {
                el.addEventListener('mouseover', (ev) => {
                    if (this.hoverNav === false && this.hoverTouchElement === null) {
                        this.openMegaMenu(ev.target);
                        this.hoverNav = true;
                    }
                });
            });

            this.itemNav.forEach((el) => {
                el.addEventListener('mouseleave', (ev) => {
                    this.closeMegaMenu(ev.target);
                    this.hoverNav = false;
                });
            });

            this.megamenuBackdrop.forEach((el) => {
                el.addEventListener('mouseover', (ev) => {
                    this.closeMegaMenu(ev.target);
                });
            });
            
            this.megamenuBackdrop.forEach((el) => {
                el.addEventListener('touchstart', (ev) => {
                    ev.preventDefault();
                    this.closeMegaMenuTouch(ev.target);
                    this.hoverTouchElement = null;
                });
            });

            this.itemNav.forEach((el) => {
                el.addEventListener('touchstart', (ev) => {
                    if (ev.target.closest('.js-header-item').classList.contains('js-header-item--active') && !ev.target.closest('.cc-megamenu--open')) {
                        this.closeMegaMenuTouch(ev.target);
                       
                    } else {
                        if (!ev.target.closest('.cc-megamenu--open')) {
                            ev.preventDefault();
                            this.openMegaMenuTouch(ev.target);

                            if (this.hoverTouchElement) {
                                this.closeMegaMenuTouch(this.hoverTouchElement);
                            }

                            this.hoverTouchElement = ev.target.closest('.js-header-item');

                            const active = document.querySelectorAll('.js-header-item--active');
                            active.forEach(el => {
                                el.classList.remove('js-header-item--active');
                            });

                            ev.target.closest('.js-header-item').classList.add('js-header-item--active');
                        }
                    }
                });
            });

            document.querySelector('.cc-header__nav').addEventListener('touchstart', (ev) => {
                if (ev.target.querySelector('.cc-megamenu--open')) {
                    this.closeMegaMenuTouch();
                    this.hoverTouchElement = null;
                    const active = document.querySelectorAll('.js-header-item--active');
                    active.forEach(el => {
                        el.classList.remove('js-header-item--active');
                    });
                }
            });
        }

        this.toggleAccessibilityFeatures();

        this.loginButtonJQ.on('click', () => {
            this.closeModalOnLoginPage();
        });

        this.itemBtnJQ.on('click keydown', (e) => {
            const subMenu = $(e.currentTarget).next(SELECTORS.submenu);
            if (!subMenu.length) return;

            if ((e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown' || e.type === 'mouseover') && window.isDesktop) {
                e.preventDefault();
                subMenu.addClass(CLASSES.open);
                subMenu.attr('aria-hidden', 'false');
                subMenu.removeAttr('tabindex');
            } else if ((e.type === 'click' || e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') && !window.isDesktop) {
                e.preventDefault();
                subMenu.addClass(CLASSES.open);
                this.submenuStack.push(subMenu);
            }
        });

        this.itemNavJQ.on('keydown', (e) => {
            if (e.key === 'Escape' && window.isDesktop) {
                e.preventDefault();
                const submenu = $(e.currentTarget).hasClass(CLASSES.open) ? $(e.currentTarget) : $(e.currentTarget).closest('.cc-header__megamenu--open');
                $(submenu).removeClass(CLASSES.open);
                $(submenu).attr('aria-hidden', 'true');
                $(submenu).attr('tabindex', '-1');
                $(submenu).closest(SELECTORS.itemNavigation).children('a').trigger('focus');
            }
        });

        this.itemBtnJQ.on('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                var subMenu = $(e.currentTarget).next(SELECTORS.submenu)
                if ((subMenu.length > 0) && window.isDesktop) {
                    subMenu.addClass(CLASSES.open);
                    $(e.currentTarget).attr('aria-hidden', 'false');
                    $(e.currentTarget).removeAttr('tabindex');
                }
            }
        });

        this.submenuJQ.on('keydown', (e) => {
            if (e.key === 'Escape' && window.isDesktop) {
                e.preventDefault();
                e.stopPropagation();
                const submenu = $(e.currentTarget).hasClass(CLASSES.open) ? $(e.currentTarget) : $(e.currentTarget).closest('.cc-header__megamenu--open');
                $(submenu).removeClass(CLASSES.open);
                $(submenu).attr('aria-hidden', 'true');
                $(submenu).attr('tabindex', '-1');
                $(submenu).closest(SELECTORS.itemNavigation).children('a').trigger('focus');
            }
        });

        this.mobileMenuJQ.on('keydown', (e) => {
            if (e.key === 'Escape' && !window.isDesktop) {
                this.toggleMenuMobile();
            }
        });

        $(window).on('resize', () => {
            this.toggleAccessibilityFeatures();
        });
    }

    openMegaMenuTouch(el) {
        const subMenu = el.closest(SELECTORS.itemNavigation).querySelector(SELECTORS.submenu);
        subMenu.classList.add(CLASSES.open);
    }

    closeMegaMenuTouch(el) {
        const subMenu = el ? el.closest(SELECTORS.itemNavigation).querySelector(SELECTORS.submenu) : document.querySelector(`.js-header-item--active ${SELECTORS.submenu}`);
        subMenu.classList.remove(CLASSES.open);
    }

    openMegaMenu(el) {
        const subMenu = el.closest(SELECTORS.itemNavigation).querySelector(SELECTORS.submenu);
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => {
            subMenu.classList.add(CLASSES.open);
        }, DELAY_OPENING_MEGA_MENU); //  delay before applying hover effect
    }

    closeMegaMenu(el) {
        const subMenu = el.closest(SELECTORS.itemNavigation).querySelector(SELECTORS.submenu);
        clearTimeout(this.hoverTimeout); // Cancel opening if user leaves early
        setTimeout(() => {
            subMenu.classList.remove(CLASSES.open);
        }, DELAY_OPENING_MEGA_MENU); //  delay before closing
    }

    /**
     * Toggle accessibility features. If the user is on mobile, we will add the modal accessibility features to the menu and its subpanels 
     */
    toggleAccessibilityFeatures() {
        accessibleModal(this.loginButtonJQ);

        if (window.isDesktop) return;

        this.mobileMenuJQ.attr('role', 'dialog');
        this.mobileMenuJQ.attr('aria-modal', 'true');
        this.mobileMenuJQ.attr('aria-hidden', 'true');
        this.mobileMenuJQ.attr('tabindex', '-1');
        this.mobileMenuJQ.attr('aria-labelledby', 'mobile-menu-trigger');

        accessibleModal(this.itemOpenMenuJQ);

        if (this.itemBtnJQ.length > 0) {
            this.itemBtnJQ.each((index, element) => {
                accessibleModal($(element));
            });
        }
    }

    /**
     * Toggle mobile menu 
     */
    toggleMenuMobile() {
        $('body').toggleClass('cc-body-no-scroll');
        this.mobileMenuJQ.toggleClass(CLASSES.mobileOpen);
        this.itemOpenMenuJQ.toggleClass(CLASSES.mobileOpen);

        if (!this.mobileMenuJQ.hasClass(CLASSES.mobileOpen)) {
            this.submenuStack = [];
            $(SELECTORS.submenu).removeClass(CLASSES.open);
        }

        this.itemOpenMenuJQ.attr('aria-expanded', this.mobileMenuJQ.hasClass(CLASSES.mobileOpen));
    }

     /**
     * Close login modal on login page 
     */
    closeModalOnLoginPage() {
        if (window.isMobile) {
            if ($('body').hasClass((CLASSES.bodyClassLogin))) {
                this.mobileMenuJQ.removeClass(CLASSES.mobileOpen);
                this.itemOpenMenuJQ.removeClass(CLASSES.mobileOpen);
                this.itemOpenMenuJQ.attr('aria-expanded', this.mobileMenuJQ.hasClass(CLASSES.mobileOpen));
                $('body').removeClass('cc-body-no-scroll');
            }
        } 
    }

    /**
     * Check the current URL and add the `active` class to the corresponding menu item.
     */
    checkActiveStateFromURL() {
        const currentURL = window.location.href;
        this.linksJQ.each((index, link) => {
            const href = $(link).attr('href');
            if (href && currentURL.includes(href)) {
                $(link).addClass(CLASSES.active).attr('aria-current', 'page');
            }
        });
    }

    /**
     * add open class on clicking item head
     * @param {HTMLElement} el
     */
    onClickHead(el) {
        el.closest('.js-megamenu__column').classList.add('cc-megamenu__column--open');
    }

    /**
     * remove open class on clicking back button
     * @param {HTMLElement} el
     */
    onClickBack(el) {
        const elOpen = el.closest('[class*="--open"]');
        const classNameOpen = elOpen.classList.value.match(/cc-\S+--open/)[0];
        elOpen.classList.remove(classNameOpen);
    }

    customClicks() {
        document.addEventListener('customClick', (ev) => {
            const elHead = ev.detail.target.closest('.js-megamenu__item--head');
            if (elHead) {
                if (window.isMobileOrTablet) this.onClickHead(elHead);

                // Prevents mobile and tablet from redirecting to the category page when the A tag is clicked. 
                if (ev.detail?.target && window.isMobileOrTablet) {
                    ev.detail.preventDefault();
                }
            }

            const elBack = ev.detail.target.closest('.js-megamenu__back');
            if (elBack) {
                this.onClickBack(elBack);
            }

            if (ev.detail.target.closest(SELECTORS.openMobileMenu)) {
                this.toggleMenuMobile();
            }
        });
    }
}

module.exports = () => {
    document.querySelectorAll(SELECTORS.element).forEach((el) => {
        new Header(el);
    });
}

